// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"268":"7634ef13","551":"43bf840e","640":"3b482245","707":"fa68d173"}[chunkId] + ".chunk.js";
};